import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export const coreAuditWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [{ path: '/admin/audit', component: () => import('./pages/AuditPage.js') }],
});
